import React from 'react';
import BackTo from "../Components/LinkBackTo/LinkBackTo";
const CategoriesAdmin = () => {
  return (
    <div>
       <BackTo move="/" nameback="HOME"/>
    </div>
  )
};

export default CategoriesAdmin;
